import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  dropdownContainer: {
    width: 380,
  },
});
